<template>
    <div id="endowloadDetail" class="bbox" :class="{ bboxactive: $route.query.type == 3 }">
        <div class="endowloadDetail-head" v-if="$route.query.type !=3 "
        >
            <img :src="list.pic" alt="" class="banner" ondragstart="return false;" oncontextmenu="return false;">
            <div class="endowloadDetail-description">
                <div class="title">
                    <div class="title-txt flex align-cen">
                        {{list.appName}}
                        <div class="video flex align-cen" v-if="list.videoUrl" @click="openVideo">
                         <i class="icon-al-playcircle"></i>播放视频
                        </div>
                    </div>
                </div>
                <div class="desc">{{list.description}}</div>
                <div class="endowloadDetail-description-btn flex align-cen" v-if="list.type !=4">
                    <div class="open" @click="openReg" v-if="list.payType == 1">立即开通</div>
                    <div class="open" @click="openReg1" v-if="list.payType == 2 || list.payType == 3">在线申请</div>
                     <div class="open"  v-if="list.type == 2 && lotoken"  @click="openEnbussAdmin(1)">进入后台</div>
                    <div class="dowload" @click="dowloadFun" v-if="list.type == 1 && $route.query.type == 1">
                        下载客户端
                    </div>
                    <div class="dowload" @click="dowloadFun" v-if="list.type == 1 && $route.query.type == 2">
                        <a :href="list.downloadUrl">下载电脑客户端</a>
                         <!-- <a :href="list.appDownloadUrl">下载手APP</a> -->
                    </div>
                     <div class="dowload" @click="dowloadFun" v-if="list.type == 1 && $route.query.type == 2">
                        <!-- <a :href="list.downloadUrl">下载电脑客户端</a> -->
                         <a :href="list.appDownloadUrl">下载手机APP</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="item-gradient">
            <div class="p-lg">
                <i class="icon-al-applicationgroup" v-if="!list.videoUrl"></i>
                 <i class="icon-al-playcircle" v-if="list.videoUrl" @click="openVideo"></i>
                <h1>{{list.appName}}</h1>
                <h3>{{list.description}}</h3>
                    <div class="endowloadDetail-description-btn flex align-cen" v-if="list.type !=4">
                    <div class="open" @click="openReg" v-if="list.payType == 1">立即开通</div>
                    <div class="open" @click="openReg1" v-if="list.payType == 2 || list.payType == 3">在线申请</div>
                       <div class="dowload"  v-if="list.type == 2 && lotoken"  @click="openEnbussAdmin(1)">进入后台</div>
                      <div class="dowload"
                      v-if="list.type == 1"
                      @click="handleDownload(list.appDownloadUrl)"
                      >
                       下载手机APP
                    </div>
                </div>
            </div>
        </div>
        <div class="endowloadDetail-contaniner"
        v-if="(list.platformAppContentList && list.platformAppContentList.length>0) || (list.appSkuList && list.appSkuList.length > 0) || (list.appResourceList && list.appResourceList.length > 0)"
        id="nr1"
        >
        
            <div class="ace-dbl-nav-channel" :class="{ fixed: isFixed }"
            v-if="$route.query.type != 3"
            >
                <div class="mod">
                <div class="inner flex align-cen">
                <div class="nav-text"
                @click="toBox(-1)"
                :class="{ active: currentNav == '-1' }"
                v-if="list.appSkuList && list.appSkuList.length > 0 && list.payModel == 1 && $route.query.type !=3"
                >产品规格</div>
                   <div class="nav-text"
                @click="toBox(-1)"
                :class="{ active: currentNav == '-1' }"
                v-if="list.appResourceList && list.appResourceList.length > 0 && $route.query.type !=3"
                >进入实验</div>
                <div class="nav-text"
                 v-for="(item,index) in list.platformAppContentList"
                :key="index"
                :class="{ active: currentNav == index }"
                @click="toBox(index)"
                >{{item.title}}</div>
            <div class="nav-text"
                @click="toBox(list.platformAppContentList.length)"
                :class="{ active: currentNav == list.platformAppContentList.length }"
                v-if="appGl && appGl.length > 0 && $route.query.type !=3"
                >关联应用</div>
                  <div class="nav-text"
                @click="toBox(list.platformAppContentList.length + 1)"
                :class="{ active: currentNav ==  list.platformAppContentList.length + 1}"
                v-if="this.list.relateCaseList && this.list.relateCaseList.length > 0 && $route.query.type !=3"
                >相关案例</div>
                </div>
                </div>
            </div>
            <div class="scene j-content1" 
             v-if="list.appResourceList && list.appResourceList.length > 0  && $route.query.type !=3"
            >
            <div class="retab">
                                  <el-table
                      :data="list.appResourceList"
                      border
                      :header-cell-style="{background:'#f7f8fa',color:'#333'}"
                      >
                       <el-table-column label="资源" align="center">
                            <template slot-scope="scope">
                                <div class="flex thrumbRe align-cen">
                                    <img :src="scope.row.resourcePic" alt="" class="reimg">
                                    <span>{{scope.row.resourceName}}</span>
                                </div>
                            </template>
                       </el-table-column>
                        <el-table-column label="资源类型" align="center">
                             <template slot-scope="scope">
                                <div>{{scope.row.resourceType == 1 ? 'PC版本仿真软件':'WEB仿真软件'}}</div>
                             </template>
                        </el-table-column>
                            <el-table-column label="操作" align="center" >
                        <template slot-scope="scope">
                         <el-button type="text" size="small" style="color:red" @click.stop="open3dView(scope.row)">进入试验</el-button>
                        </template>
                       </el-table-column>
                  </el-table>
            </div>
            </div>
            <div class="scene j-content1" 
             v-if="list.appSkuList && list.appSkuList.length > 0 && list.payModel == 1 && $route.query.type !=3"
            >
                <div class="ace-tab-goods-card">
                    <div class="sku-goods-wrap">
                        <div class="sku-goods-grid">
                            <div class="ace-row ace-row-wrap sku-goods-row goods-simple-row">
                                <div class="ace-col ace-col-6 sku-goods-col-simple"
                                v-for="(item,index) in list.appSkuList"
                                :key="index"
                                >
                                    <div class="goods-card-simple">
                                        <div class="simple-card-header">
                                            <div class="simple-header-title">
                                                 {{item.name}}
                                            </div>
                                        </div>
                                        <div class="simple-content-form">
                                            <div class="ace-form ace-medium">
                                                <div class="form-item-list flex align-cen">
                                                    <div class="ace-form-item-label ace-left">
                                                        账号个数
                                                    </div>
                                                    <div class="ace-form-item-label ace-right">
                                                        {{item.accountNum || '无限制'}}
                                                    </div>
                                                </div>
                                                 <div class="form-item-list flex align-cen">
                                                    <div class="ace-form-item-label ace-left">
                                                      使用期限(月)
                                                    </div>
                                                    <div class="ace-form-item-label ace-right">
                                                        {{item.deadline || '无限期'}}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="simple-price-box">
                                            <div class="simple-show-label">
                                                <span class="tag-item-text">
                                                 {{ discount(item) }}
                                                </span>
                                            </div>
                                            <div class="right-price-box flex ">
                                                 <div class="price-content price-content1 flex">
                                                        <div class="price-icon" style="margin-right:5px">¥</div>
                                                        <div class="price-trade">{{item.originalPrice}}</div>
                                                </div>
                                                <div class="price-content flex">
                                                        <div class="price-icon" style="margin-right:5px">¥</div>
                                                        <div class="price-trade">{{item.salePrice}}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="buy-button-box" @click="openBuy(index,item)">
                                         立即购买
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
             <div class="scene j-content" 
             :class="{ jcontent1: $route.query.type == 3 }"
                      v-for="(item,index) in list.platformAppContentList"
                    :key="index"
             >
                  <div class="quedior">
                        <h2 v-if="$route.query.type != 3">{{item.title}}</h2>
                        <div class="subtitle " v-if="$route.query.type != 3">{{item.subhead}}</div>
                        <div v-html="item.content" class="nr" v-if="!$util.isMobile()"></div>
                        <div v-html="item.mobileContent ? item.mobileContent : item.content" class="nr" v-if="$util.isMobile()"></div>
                    </div>
             </div>
        </div>
        <!-- <div class="endowloadDetail-contaniner endowloadDetail-contaniner1" v-else>
            <span class="icon-al-wind-cry"></span>
            <p>暂无数据</p>
        </div> -->
                <div class="fzadmin-module scene j-content" v-if="$route.query.type !=3 && appGl && appGl.length > 0"> 
            <div class="componenet-wrap">
                关联应用
            </div>
            <div class="inner  flex align-cen">
                <div class="ltr-r"
            v-for="(item,index) in appGl"
                :key="index"
                @click="openApp(item)"
             >
                 <div class="ltr"
                 
            >
                <div class="cardContent">
                    <div class="pic-area">
                        <img :src="item.pic" alt="" ondragstart="return false;" oncontextmenu="return false;">
                    </div>
                    <div class="title">{{item.appName}}</div>
                    <div class="description">{{item.description || '暂无描述'}}</div>
                </div>
            </div>
                </div>
            </div>
        </div>
        <!-- 关联案例 -->
         <div class="fzadmin-module scene j-content"  style="background:#fff"  v-if="list.relateCaseList.length"> 
           <div class="componenet-wrap">
                客户案例
            </div>
            <div class="card-container">
                <div class="containers">
                    <div class="list">
                        <div class="itemList flex align-cen"
                          v-for="(item,index) in list.relateCaseList"
                            :key="item.id"
                            @click="openDetail(item)"
                        >
                            <div class="img">
                                 <img :src="item.pic || require('../../assets/images/defuletNews.jpg')" alt="">
                            </div>
                            <div class="imgInfo">
                                <div class="title">{{item.name}}</div>
                                <p class="infoClick"><span class="detail">查看详情+</span></p>
                            </div>
                        </div>
                    </div>
                </div>
          </div>
         </div>
        <goTop></goTop>
      <div class="mask" v-if="centerDialogVisible" @click="centerDialogVisible=false">
        <div class="video-wrap">
           <video :src="list.videoUrl"  type="video/*" controls autoplay style="width:100%;height:100%"  @click.stop=""></video>
        </div>
      </div>
    </div>
</template>
<script>
import { dowloadDetail,accountClue,enBusiness} from "@/api/enterprise/index" // 下载详情、线索、
import debounce from '../../utils/debounce.js' //防抖
import LocaStorage from "../../utils/localstorage.js"
import goTop from '@/components/goTop'
import "../../assets/styles/font.css";
export default {
    name:'endowloadDetail',
    data() {
        return {
            clcikStatu:false,
            centerDialogVisible:false,
            currentNav:0,
            list:{
                
            },
            tabPosition:'top',
            isFixed: false,
            contentTopList:[],
            isClick:false,
            lotoken:false,
            appGl:[],
            isTearch:false,
            bussID:''
        }
    },
    components:{
        goTop
    },
    computed: {
        defaultBgImg() {
            let str = [
                {backgroundImage:'url(' + this.list.appImagesList[0].imgUrl + ')',backgroundRepeat:'no-repeat'},
            ]
            return str
        },
       discount(){
        return item => {
            if(item.salePrice / item. originalPrice == 1) return '暂无折扣'
            let dinum = (item.salePrice / item. originalPrice ) * 10
            let str = String(dinum),
                spstr = str.split("");
               
            if(spstr[spstr.length-1] == 0){
                dinum = str.substring(0, str.length-1);  
            }else if( str.substr(0, 1) == 0){
               dinum =  dinum
            }
            else{
                dinum = parseInt(dinum)
            }
           
            return dinum.toFixed(2) + '折'
        }
       }
    },
      watch:{
         $route() {
          if(this.$route){
            if(this.$util.isMobile()){
                 this.getInfo()
            }
         }
    }
    },
    mounted() {
    window.addEventListener('scroll', this.handleScroll) // 监听滑动事件
  },
    created(){
         const businessInfo = LocaStorage.setAge().get('businessInfo')
        if(businessInfo){
             this.bussID = businessInfo.id
        }
        this.getInfo() 
         if(this.$route.query.IsService == 1){
            this.openReg1(1)
        }
         if( this.$route.query.type == 3) this.$bus.$emit("isShow", false);
         this.lotoken = LocaStorage.setAge().get('token1') ? true : false
        
    },
    methods: {
          // 判断是否为微信浏览器
    isWechatBrowser() {
      const userAgent = navigator.userAgent.toLowerCase()
      return userAgent.includes('micromessenger')
    },
        // 下载app
        handleDownload(downloadUrl){
            if(this.isWechatBrowser()){
                 this.$util.Notifi('请点击右上角，选择"在浏览器中打开"进行下载','error','fa-exclamation-circle');
            }else{
                window.location.href = downloadUrl;
            }
        },
        // 打开3d
        open3dView(data){
               // let windowName = `popup${Date.now()}`
            let path= `${data.resourceUrl}?t=${new Date().getTime()}`
            //    window.open(path,windowName)
             window.open(path, `_blank`); // 使用'_blank'总是会打开新窗口
        },
        // 打开企业后台
        openEnbussAdmin(type){
        
            if(type == 1){
                    // 教师管理端后台
                  enBusiness({},'enterprise')
            .then(res =>{
                if(res.code == 0){
                 if(res.data.length == 1){
                  localStorage.removeItem('businessInfo')
                 LocaStorage.setAge().set('businessInfo',res.data[0])
                        if(this.$util.isMobile()){
                            // 手机点击进入后台时
                            this.$router.push('/webenterprise/mobileCenter')
                        }else{
                            // pc点击进入后台时
                            const newurl = this.$router.resolve({path:'/webenterpriseManage/index', query: {}})
                            window.open(newurl.href,'_blank')
                        }
                }else{
                const newurl = this.$router.resolve({name:'enBusiness', query: {}})
                 window.open(newurl.href,'_blank')
                }
                }else{
                     this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
                }
            })
            }else{
                // 其他普通网页
                if(this.list.resourceUrl.includes('/myExam/testingCenter')){
                       this.$router.push({
                 name:this.$util.isMobile() ? 'mobileMyExamIndex' : 'testingCenterIndex',
                query: {
                    businessId : this.bussID
                }
            })
                }else{
                    window.open(this.list.resourceUrl,'_black')
                }
            }
        },
        // 打开视频弹窗
        openVideo(){
            this.centerDialogVisible = true
        },
        // 打开购买页面
        openBuy(index,data){
            let dataJson = {
            id:this.$route.query.id,
            index:index,
            data:data
           }
            if(this.$route.query.type == 3){
                 const newurl = this.$router.resolve({name: 'creatOrder', query: {dataJson : this.$base64.encode(JSON.stringify(dataJson))}})
                 window.open(newurl.href,'_blank')
            }else{
                this.$router.push({
                 name: "creatOrder",
                query: {
                    dataJson : this.$base64.encode(JSON.stringify(dataJson))
                }
            })
            }
            // if(LocaStorage.setAge().get('token1')){
           
            // }else{
            //     this.$message.error('请先登录')
            //     this.$router.push({
            //         name:'enLogin',
            //         query:{
            //             id: this.$route.query.id,
            //             redirectUrl:'endowloadDetail',
            //             type:2
            //         }
            //     })
            // }
            // if(this.$util.isMobile()) return this.$message.error('请在电脑上完成支付')
            //  const { href } = this.$router.resolve({
            //         name: "creatOrder",
            //         query:{id:this.$route.query.id,index:index,data:JSON.stringify(data)}
            //     });
            //  window.open(href, "_blank");
        },
        // 打开注册页面
        openReg(){
             if(LocaStorage.setAge().get('token1')){
                if(this.clcikStatu){
                     this.$util.Notifi('请勿重新申请！','error','fa-exclamation-circle');
                }else{
                accountClue({
                appId:this.$route.query.id,
                officialType:1
                },'enterprise')
                .then(res =>{
                    if(res.code == 0){
                        this.$util.Notifi('您已申请开通，请等待工作人员联系您','success','fa-check'); 
                        this.$router.replace({ name: 'endowloadDetail', query: { id: this.$route.query.id, type:2, } })
                        this.clcikStatu = true
                    }else{
                         this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
                    }
                })
                }
             }else{
                const newurl = this.$router.resolve({name: 'register', query: {appId: this.$route.query.id,type:1}})
                 window.open(newurl.href,'_blank')
             }
        },
        openReg1(){
            if(LocaStorage.setAge().get('token1')){
                 if(this.clcikStatu){
                         this.$util.Notifi('请勿重新申请！','error','fa-exclamation-circle');
                 }
                 else{
                             accountClue({
                appId:this.$route.query.id,
                officialType:1
                },'enterprise')
                .then(res =>{
                    if(res.code == 0){
                        this.$util.Notifi('您已申请，请等待工作人员联系您','success','fa-check'); 
                          this.$router.replace({ name: 'endowloadDetail', query: { id: this.$route.query.id, type:2, } })
                             this.clcikStatu = true
                    }else{
                         this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
                    }
                })
                .catch(err =>{
                     this.$util.Notifi('出错了！','error','fa-exclamation-circle');
                })
                 }
            }else{
                    const newurl = this.$router.resolve({name: 'enLogin', query: {id: this.$route.query.id,redirectUrl:'endowloadDetail',type:2}})
                 window.open(newurl.href,'_blank')
            }
              
        },
        // 打开关联应用
        openApp(data){
             const newurl = this.$router.resolve({name: 'endowloadDetail', query: {id: data.relatedAppId,type:this.$route.query.type}})
        window.open(newurl.href,'_blank')
        },
        // 下载
        dowloadFun(){
            if(this.$route.query.type == 1) return this.$message.info('仅支持预览')
        },
    // 点击tab
    toBox(index) {
    // 点击滚动到指定的位置，要去掉滚动的过程中因为位置变化带来的效果
      this.isClick = true
      this.currentNav = index
      const DOM = (index >=0 && index <=10) ? document.querySelectorAll('.j-content')[index] : document.querySelectorAll('.j-content1')[0]
      const offsetTop = DOM.offsetTop - 50
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      })
       // 过一段时间，把isClick还原
      setTimeout(() => {
        this.isClick = false
      }, 800)
    },
        // 处理滚动
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      var offsetTop 
      if(this.$route.query.type != 3) offsetTop = document.querySelector('.banner').offsetHeight
    //   if(this.$route.query.type == 3) offsetTop = 0
       // 获取所有锚点元素
      const divs = [...document.querySelectorAll('.j-content')]
      // 将所有锚点元素offsetTop push到数组内
      divs.forEach((item, index) => {
        this.contentTopList[index] = item.offsetTop - 50
      })
       // 判断当前是否是点击定位的，如果不是，才有滚动定位的效果
      if (!this.isClick) {
        let navIndex
        // 滚动定位tab高亮的状态
        for (let i = 0; i < this.contentTopList.length; i++) {
          // 如果当前滚动的top坐标大于第i个的top坐标，就记录下i。记录到最后，i就会是最后一个满足条件的i，也就是刚刚好的那个值
          if (scrollTop >= this.contentTopList[i]) {
            navIndex = i
          }
        }
        // 把下标赋值给 vue 的 data
        this.currentNav = navIndex
        if (typeof navIndex !== 'number') {
            if(this.list.appSkuList &&this.list.appSkuList.length > 0 && this.list.payModel == 1 && this.$route.query.type == 2){
                this.currentNav = '-1'
            }
            else{
                this.currentNav = 0
            }
          
        }
      }
      // 吸顶效果
        if (scrollTop > offsetTop) {
          this.isFixed = true
        } else {
          this.isFixed = false
        }
                  //防抖触发
        debounce(() => {
            this.$bus.$emit("fixedState",this.isFixed);
        }, 300)
         
    },
              // 打开详情
        openDetail(data){
            if(data.contentType == '2'){
                let path=data.content
               window.open(path,'_black')
             }else{
              const newurl = this.$router.resolve({name: 'enCaseDetail', query: {id: data.caseId}})
                window.open(newurl.href,'_blank')
             }
            
        },
        getInfo(){
              dowloadDetail({
                id:this.$route.query.id,
            },'enterprise')
            .then(res => {
             this.$bus.$emit("helpID", res.data.supportId);
             document.title= res.data.appName
              res.code == 0 ?  this.list = res.data : this.list = {},this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
              this.appGl = res.data.platformAppRelationList 
            if(res.data.appSkuList.length || res.data.appResourceList.length ){
                this.currentNav = -1
            }
                 this.$nextTick(function(){
                 const imgDomArray = document.getElementById('nr1')
             imgDomArray.setAttribute('ondragstart','return false')
             imgDomArray.setAttribute('oncontextmenu','return false')
              })
            })
            .catch(err => {
                this.$util.Notifi(err.msg,'error','fa-exclamation-circle');
            })
        },
    },
      destroyed() {
    window.removeEventListener('scroll', this.handleScroll) // 销毁监听滑动事件
  },
}
</script>
<style>
.j-content .nr p img{
display: block;
margin: 0 auto;
}
</style>
<style lang="scss" scoped>
          .card-container{
        width: 100%;
        margin: 0 auto;
        padding-bottom: 62px;
        margin-top: 20px;
        .containers{
            max-width: 1540px;
            padding: 0 15px;
            margin: 0 auto;
            .list{
                .itemList{
                 border-bottom: 1px solid #EEEEEE;
                 padding: 36px 0;
                 .img{
                    width: 20%;
                    vertical-align: middle;
                    img{
                           object-fit: cover;
                            width: 100%;
                            max-height: 196px;
                    }
                 }
                 .imgInfo{
                    width: 75%;
                    vertical-align: middle;
                    padding-left: 56px;
                    cursor: pointer;
                    .title{
                    font-size: 20px;
                    color: #333333;
                    max-width: 650px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 1;
                    -webkit-box-orient: vertical;
                    }
                    p{
                        cursor: pointer;
                    }
                    .dateTit{
                        padding: 19px 0;
                        span{
                            color: #666;
                        }
                        .data{
                            font-size: 14px;
                            font-weight: 500;
                            line-height: 30px;
                            padding-left: 10px;
                        }
                    }
                    .newInfo{
                        font-size: 14px;
                        font-weight: 500;
                        color: #999999;
                        line-height: 24px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                    }
                    .infoClick{
                        padding-top: 24px;
                        span{
                            font-size: 16px;
                            font-weight: 500;
                            color: #666666;
                            line-height: 24px;

                        }
                    }
                 }
                }
                .itemList:hover{
                        background: #F6F6F6;
                        .imgInfo{
                            .title{
                                color: #2893f1;
                            }
                            .infoClick{
                                span{color: #2893f1;}
                            }
                        }
                }
            }
        }
    }
.mask{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,.6);
    z-index: 1000;
    .video-wrap{
       position: absolute;
        width: 960px;
        height: 540px;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        transition: all .3s ease-in;
        z-index: 2000;
        }
    .video-wrap::before{
            position: absolute;
            right: 0;
            top: -50px;
            content: "";
            width: 40px;
            height: 40px;
            cursor: pointer;
            background: url('../../assets/images/videoclose.png');
            background-size: 100% 100%;
            }

}
#endowloadDetail{
    .item-gradient{
        display: none;
    }
    .fzadmin-module{
      background-color:#f4f4f4;
      .componenet-wrap{
        padding: 50px 0 10px;
        text-align: center;
        font-size: 32px;
            color: #181818;
            max-width: 1280px;
            margin: 0 auto;
            font-weight: bold;
      }
      .inner{
        width: 1280px;
        padding-top: 20px;
        margin: 0 auto;
        padding-bottom: 50px;
        flex-wrap: wrap;
        .ltr-r{
            margin-left: -10px;
            padding-left: 10px;
             padding-right: 10px;
             margin-bottom: 20px;
             cursor: pointer;
             width: 32%;
             .cardContent{
                background: #fff;
                border: 1px solid #ededed;
                overflow: hidden;
            padding-bottom: 20px;
            
            .pic-area{
                overflow: hidden;
                 position: relative;
                 img{
                   height: 119px;
                    width: 100%;
                     object-fit: cover;
                 }
            }
            .title{
                height: 24px;
            line-height: 24px;
            padding: 0 20px;
            font-size: 16px;
            color: #181818;
            font-weight: 500;
            overflow: hidden;
            margin-top: 20px;
            margin-bottom: 8px;
            }
            .description{
                color: #3d3d3d;
                line-height: 24px;
                padding: 0 20px;
                font-size: 14px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                padding-bottom: 20px;
            }
             }
             .cardContent:hover{
                box-shadow: 0 0 15px 0 rgb(0 0 0 / 10%);
    transition: all .3s;
             }
        }
      }
    }
    .endowloadDetail-head{
        position: relative;
        // background-size: cover;
        img{
        position: absolute;
    top: 0;
    width: 100%;
    left: 0;
    height: 100%;
    background-repeat: no-repeat;
    background-position: top;
    background-size: cover;
    object-fit: cover;
        }
        .endowloadDetail-description{
         max-width: 1280px;
         margin: 0 auto;
        padding-top: 16px;
               min-height: 560px;
               position: relative;
               z-index: 1;
         .title{
             margin-top: 150px;
             font-size: 0;
             .title-txt{
                display: inline-block;
                vertical-align: middle;
                font-size: 36px;
                line-height: 48px;
                color: #323233;
                .video{
                display: inline-block;
                vertical-align: middle;
                padding: 0 12px;
                height: 28px;
                line-height: 28px;
                background-color: #d8d8d8;
                text-align: center;
                color: #181818;
                font-size: 12px;
                cursor: pointer;
                margin-left: 5px;
                i{
                margin-right: 7px;
                display: inline-block;
                vertical-align: -1px;
                }
                }
             }
         }
          .desc{
            margin-top: 10px;
            font-size: 14px;
            line-height: 24px;
            max-height: 72px;
            overflow: hidden;
            width: 60%;
            color: #323233;
          }
            .endowloadDetail-description-btn{
                margin-top: 40px;
                div{
                    min-width: 140px;
                    cursor: pointer;
                    border: none;
                    box-shadow: inset 0 0 1px 1px #000000;
                    font-weight: 400;
                    font-size: 18px;
                    text-align: center;
                    vertical-align: middle;
                    background-color: transparent;
                    border-radius: 5px;
                    margin-right: 20px;
                    padding: 5px 0;
                    color: #323233;
                    a{
                        color: #323233;
                    }
                }
                 div:hover{
                    background: linear-gradient(230.47deg, #FFA41C -0.87%, #FE4141 25.89%, #F4153E 77.87%, #FF27C3 97.94%), #E73828;
                    font-weight: 700;
                    box-shadow: none;
                    color: #FFFFFF;
                    a{
                       color: #FFFFFF; 
                    }
                 }
            }
        }
    }
    .endowloadDetail-contaniner{
      background-color: rgb(249, 249, 249);
      .ace-dbl-nav-channel{
        height: 50px;
        position: relative;
    background-color: #fff;
    z-index: 99;
    box-shadow: 0 2px 4px 0 rgb(0 0 0 / 10%);
    .inner{
        max-width: 1280px;
        margin: 0 auto;
        height: 50px;
        justify-content: center;
        .nav-text{
            vertical-align: middle;
            height: 50px;
            line-height: 50px;
            font-size: 14px;
            margin-right: 50px;
            font-weight: 400;
            font-stretch: normal;
            letter-spacing: 0;
            color: #181818;
            cursor: pointer;
        }
        .active{
            color: #155bd4;
            border-bottom: 3px solid #155bd4;
        }
    }
      }
      .fixed{
         position: fixed;
        top: 0px;
        left: 0;
        right: 0;
        z-index: 10;

      }
      .j-content{
        max-width: 100%;
        width: 100%;
        margin: 0 auto;
        padding: 50px 0px 10px;
        h2{
        font-size: 32px;
        color: rgb(24, 24, 24);
        line-height: 42px;
        margin-bottom: 12px;
         position: relative;
         text-align: center;
         font-weight: bold;
        }
        .subtitle {
            font-size: 16px;
    color: #333;
    line-height: 24px;
     text-align: center;
     padding-bottom: 10px;
        }
      }
      .j-content1{
         width: 100%;
         max-width: 100%;
         padding: 0px;
         .retab{
            padding: 20px 0 50px;
                box-sizing: border-box;
                margin: 0 auto;
                width: 1200px;
                .reimg{
                    width: 150px;
                    height: 60px;
                    margin-right: 20px;
                }
         }
         .ace-tab-goods-card{
                padding: 20px 0 50px;
                box-sizing: border-box;
                margin: 0 auto;
                width: 1200px;
            .sku-goods-wrap{
                min-height: 220px;
                transition: all .3s;
                .goods-simple-row{
                 padding: 5px 0;
                 margin: 0 -10px;
                 flex-wrap: wrap;
                 display: flex;
                 .sku-goods-col-simple{
                        padding: 5px 10px;
                    box-sizing: border-box;
                        flex: 0 0 25%;
                    width: 25%;
                    max-width: 25%;
                    .goods-card-simple{
                        background: #fff;
                        position: relative;
                        border: 1px solid #ededec;
                        transition: box-shadow .3s ease-out;
                        .simple-card-header {
                            padding: 0 20px 10px;
                            padding-top: 28px;
                            box-sizing: border-box;
                            background: rgb(235, 236, 236);
                            .simple-header-title{
                                position: relative;
                                text-align: left;
                                font-size: 18px;
                                color: #181818;
                                letter-spacing: .55px;
                                line-height: 30px;
                                margin-bottom: 8px;
                                font-weight: 600;
                                transition: all .3s;
                            }
                        }
                        .simple-content-form {
                            padding: 8px 20px;
                            box-sizing: border-box;
                            .ace-medium{
                                width: 100%;
                                .form-item-list{
                                    box-sizing: border-box;
                                    margin-bottom: 3px;
                                    .ace-form-item-label {
                                        font-size: 14px;
                                        padding-right: 0;
                                            display: inline-block;
                                            vertical-align: top;
                                            color: #999;
                                    }
                                    .ace-right{
                                       padding-left: 40px;
                                        color: #3d3d3d;
                                    }
                                }
                            }
                        }
                        .simple-price-box {
                            padding: 0 20px;
                            box-sizing: border-box;
                            border-top: 1px solid #ebecec;
                            .simple-show-label{
                                    margin-top: 12px;
                                    margin-bottom: 12px;
                                   
                                    .tag-item-text{
                                        background:  #155bd4;
                                    border-radius: 2px;
                                    text-align: left;
                                    font-size: 12px;
                                    color: #fff;
                                    letter-spacing: .46px;
                                    display: inline-block;
                                    padding: 2px 12px;
                                    line-height: 20px;
                                    margin-right: 8px;
                                    }
                            }
                            .right-price-box{
                                    margin-bottom: 14px;
                                   margin-top: 20px;
                             .price-content{
                                margin-bottom: 4px;
                                .price-icon{
                                    color: #ea3a3a;
                                    font-size: 16px;
                                    letter-spacing: .81px;
                                }
                                .price-trade{
                                        text-align: left;
                                    color: #ea3a3a;
                                    line-height: 26px;
                                    font-size: 24px;
                                    letter-spacing: 1.2px;
                                }
                             }
                             .price-content1{
                                margin-right: 20px;
                                .price-icon,.price-trade{color: #999; text-decoration: line-through;}
                             }
                            }
                        }
                        .buy-button-box{
                            width: 100%;
                            height: 36px;
                            text-align: center;
                            line-height: 36px;
                            color: #fff;
                            background: #ea3a3a;
                            cursor: pointer;
                        }
                    }
                    .goods-card-simple:hover{
                        box-shadow: 0 0 15px 0 rgb(0 0 0 / 10%);
                    }
                 }
                }
            }
         }
      }
    }
    .endowloadDetail-contaniner1{
        text-align: center;
        padding: 150px 0;
        span{
            font-size: 50px;
        }
    }
}
.bboxactive{
     height: 100vh;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
}
@media (max-width: 640px){
    .j-content1{
        .ace-tab-goods-card{
            width: 95% !important;
            margin: 0 auto !important;
            .sku-goods-wrap{
                .sku-goods-col-simple{
                    flex: none !important;
                    width: 100% !important;
                    max-width: 100% !important;
                }
            }
        }
    }
        .retab{
            padding:0 !important;
                box-sizing: border-box;
                margin-top: 20px !important;
                width: 90% !important;
                .thrumbRe {
                  display: block;
                }
                
         }
    .mask{
        .video-wrap{
            width: 95% !important;
            height: 300px !important;
        }
    }
    .fzadmin-module{
        .inner{
             width: 100% !important
        }
        .ltr-r{
            width: 90% !important;
            margin: 0 auto;
            margin-left: auto !important;
        }
    }
    .endowloadDetail-description{
        display: none;
    }
            .banner{
        position: relative !important;
    width: 100%;
   
    background-repeat: no-repeat;
    background-position: top;
    background-size: cover;
    object-fit: cover;
        }
        .ace-dbl-nav-channel{
            .inner{
                max-width: 100% !important;
                .nav-text{
                    margin-right: 0 !important;
                    padding: 0 10px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }
        }
     .item-gradient{
        padding: 10px;
          display: block !important;
          margin-top: 20px;
          
       .p-lg{
        background: #FAFAFA;
       border-radius: 10px;
        transition: all .3s;
        padding: 30px;
        text-align: center;
        border:1px solid  #D0D0D0;
        i{
            color: #000;
            font-size: 40px;
        }
         .endowloadDetail-description-btn{
            justify-content: space-evenly;;
                div{
                     min-width: 140px;
                    cursor: pointer;
                    border: none;
                    box-shadow: inset 0 0 1px 1px #000000;
                    font-weight: 400;
                    font-size: 15px;
                    text-align: center;
                    vertical-align: middle;
                    background-color: transparent;
                    border-radius: 10px;
                   margin-top: 10px;
                    padding: 5px 0;
                    a{
                        color: #000;
                    }
                }
              
                 div:hover{
                    background: linear-gradient(230.47deg, #FFA41C -0.87%, #FE4141 25.89%, #F4153E 77.87%, #FF27C3 97.94%), #E73828;
                    font-weight: 700;
                    box-shadow: none;
                    color: #fff;
                    
                 }
            }
       }
    }
}
::v-deep{
    .ql-video{
   width: 100%;
}
         .el-tabs__header{
            padding: 20px 0 !important;
            margin: 0;
        }
        .el-tabs__nav-wrap::after {
            content: none;
        }
        .el-tabs__nav-scroll{
            display: flex;
            justify-content: center;
        }
        .el-tabs__item{
            font-size: 18px;
            color: #1f292e;
            opacity: .5;
            text-align: center;
            -webkit-transition: all .2s ease-out;
            transition: all .2s ease-out;
        }
        .el-tabs__nav{
            padding: 10px 0;
           
        }
        @media (max-width: 640px){
            .el-tabs__nav{
             float: none;
             display: flex;
             flex-wrap: wrap;
            justify-content: center;
            .el-tabs__item{
                padding: 0px;
                padding-right: 20px;
                position: relative;
                margin-bottom: 5px;
                font-size: 15px;
            }
            .el-tabs__active-bar{
                display: none
            }
            .el-tabs__item.is-active::after{
                content: '';
                 width: 60px !important;
                 position: absolute;
            height: 4.4px;
            border-radius: 2px;
            bottom: -5px;
            left: 0px;
            -webkit-transition: all .2s ease-out;
            transition: all .2s ease-out;
            background-image: -webkit-linear-gradient(20deg,#298df8 4%,#1c4de3);
            background-image: linear-gradient(70deg,#298df8 4%,#1c4de3);
            -webkit-box-shadow: 0 6px 22px 0 rgb(43 41 41 / 15%);
            box-shadow: 0 6px 22px 0 rgb(43 41 41 / 15%);
            }
        }
             
        }
        .el-tabs__item.is-active {
            font-weight: 500;
             opacity: 1;
        }
        .el-tabs__active-bar{
            width: 72px !important;
            height: 4.4px;
            border-radius: 2px;
            bottom: 0;
            -webkit-transition: all .2s ease-out;
            transition: all .2s ease-out;
            background-image: -webkit-linear-gradient(20deg,#298df8 4%,#1c4de3);
            background-image: linear-gradient(70deg,#298df8 4%,#1c4de3);
            -webkit-box-shadow: 0 6px 22px 0 rgb(43 41 41 / 15%);
            box-shadow: 0 6px 22px 0 rgb(43 41 41 / 15%);
        }
}
</style>